import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import React from 'react'
import { getBgColorByGrade } from '../../../../../../components/grades/grade-badge'
import { Grade } from '../../../../helpers/ui-interfaces'

interface Props {
  grade: Grade
  isPrivate: boolean
}
export const ScoreTile = ({ grade, isPrivate = false }: Props) => {
  return (
    <div className="score-tile">
      <div
        data-testid="score-section-progress-grade"
        className={css`
          color: ${isPrivate ? theme.color.black : theme.color.white};
          font-style: normal;
          font-weight: 700;

          display: flex;
          justify-content: center;
          align-items: center;

          font-size: 75px;
          width: 80px;
          height: 80px;
          border-radius: 3px;

          background-color: ${grade.score > -1 && !isPrivate
            ? theme.color[getBgColorByGrade(grade.value)]
            : theme.color.neutral40};
        `}
      >
        {isPrivate ? '?' : grade.value}
      </div>
    </div>
  )
}
